// extracted by mini-css-extract-plugin
module.exports = {"link":"_3EXY5","root":"_2o1qa","label":"_17y_j"};